module.exports = __webpack_public_path__ + "static/media/background.1a6882c2.png";